@if (question$() && dummyControl$()) {
  <empathy-preview-wrapper>
    <empathy-question-view [question]="question$()" [questionCtrl]="dummyControl$()"></empathy-question-view>
  </empathy-preview-wrapper>
}
